import React from "react";
import { Buffer } from "buffer";
import {
  BrowserRouter,
  Link,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import About from "./About";
import Blog from "./Blog";
import BlogPost from "./BlogPost";

window.Buffer = Buffer;

function NavBar() {
  const location = useLocation();
  const onWriting = location.pathname.includes("/blog");

  return (
    <nav className="fixed left-0 right-0 top-0 z-50 border-b border-gray-100 bg-white/80 backdrop-blur-sm">
      <div className="mx-auto max-w-5xl px-6">
        <div className="flex h-16 items-center justify-between">
          <Link
            to="/"
            className="text-lg font-medium text-gray-900 transition-colors hover:text-gray-600"
          >
            Soham Jog
          </Link>

          <Link
            to="/blog"
            className={`text-sm transition-colors ${
              onWriting
                ? "text-gray-900"
                : "text-gray-500 hover:text-gray-900"
            }`}
          >
            Writing
          </Link>
        </div>
      </div>
    </nav>
  );
}

function App() {
  return (
    <BrowserRouter>
      <div className="min-h-screen bg-site pt-16 text-gray-800">
        <NavBar />
        <Routes>
          <Route path="/" element={<About />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
